import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import ChainedBackend from "i18next-chained-backend";
import I18NextLocalStorageBackend from "i18next-localstorage-backend";

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    debug: true,
    load: "languageOnly",
    fallbackLng: "en",
    backend: {
      backends: [I18NextLocalStorageBackend, HttpBackend],
      backendOptions: [
        {
          expirationTime: 10 * 1000,
        },
        {
          loadPath: `/ac/assets/locales/{{lng}}.json`,
        },
      ],
    },
  });

export default i18n;
